// extracted by mini-css-extract-plugin
export default {"root":"styles_root__LEzLQ","header":"styles_header__6hn6v"};